import { jsxs, jsx } from "react/jsx-runtime";
const IconSocialLinkedInSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M7.907 18.837H4.982v-9.4h2.925v9.4ZM6.445 8.152a1.694 1.694 0 1 1-.003-3.388 1.694 1.694 0 0 1 .003 3.388ZM18.85 18.837h-2.922v-4.572c0-1.09-.018-2.492-1.518-2.492-1.52 0-1.752 1.188-1.752 2.414v4.65H9.74v-9.4h2.8v1.284h.04c.39-.739 1.343-1.518 2.765-1.518 2.958 0 3.505 1.946 3.505 4.478v5.156ZM21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Z" })
    ]
  }
);
export {
  IconSocialLinkedInSvg
};
